import { DUAL_LANGUAGE_MARKETS } from '../constants/dualLanguageMarketConstants';

export const getIsTravelerInDualLanguageMarket = (
  travelerLocale,
  activeLocale
) => !!Object.values(
  DUAL_LANGUAGE_MARKETS
).find(
  (marketLanguages) => marketLanguages
    .includes(activeLocale) && marketLanguages.includes(travelerLocale)
);
